import * as React from 'react';
import { DocumentRegular, FolderRegular } from '@fluentui/react-icons';
import type { ITreeNode } from '../history/tree';

/** A folder tree with changed, new and set-aside items highlighted (History and the structure preview). */
export default function Tree(props: { node: ITreeNode; side: 'before' | 'after'; depth?: number; maxDepth?: number }): React.ReactElement {
  const depth: number = props.depth ?? 0;
  return (
    <ul className="tree">
      {props.node.children.map(n => {
        const label: string | undefined = n.mark === 'new' ? 'new folder'
          : n.mark === 'setAside' ? 'set aside'
            : n.mark === 'changed' ? (props.side === 'before' ? 'changes' : 'here now') : undefined;
        const deeper: boolean = n.children.length > 0 && (props.maxDepth === undefined || depth + 1 < props.maxDepth);
        return (
          <li key={n.path}>
            <span className={`tree-item ${n.mark ? `mark-${n.mark} side-${props.side}` : ''}`}>
              {n.isFolder ? <FolderRegular fontSize={16} /> : <DocumentRegular fontSize={16} />}
              <span className={n.isFolder ? '' : 'mono'}>{n.name}</span>
              {n.count !== undefined && n.count > 0 && <span className="small">{n.count} file{n.count === 1 ? '' : 's'}</span>}
              {label && <span className="tree-tag">{label}</span>}
              {!deeper && n.children.length > 0 && <span className="small">+{n.children.length} folder{n.children.length === 1 ? '' : 's'}</span>}
            </span>
            {deeper && <Tree node={n} side={props.side} depth={depth + 1} maxDepth={props.maxDepth} />}
          </li>
        );
      })}
    </ul>
  );
}
